
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 20 20\" id=\"icon-page\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <rect x=\"6.478\" y=\"12.756\" width=\"7.002\" height=\"0.963\"/> <rect x=\"6.478\" y=\"9.465\" width=\"7.002\" height=\"0.962\"/> <path d=\"M10,0C4.477,0,0,4.477,0,10c0,5.521,4.477,10,10,10c5.523,0,10-4.479,10-10C20,4.477,15.523,0,10,0z M15.132,15.413\r\n\t\tc0,0.235-0.192,0.428-0.428,0.428H5.295c-0.236,0-0.427-0.19-0.427-0.428V4.586c0-0.236,0.191-0.427,0.427-0.427h9.409\r\n\t\tc0.235,0,0.428,0.191,0.428,0.427V15.413z\"/> <rect x=\"6.478\" y=\"6.273\" width=\"7.002\" height=\"0.962\"/> </g> </symbol>";
module.exports = sprite.add(image, "icon-page");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/page.svg
 ** module id = 205
 ** module chunks = 24
 **/